import { makeStyles } from '@fluentui/react-components';

export const useCardStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  wideContainer: {
    display: 'flex',
  },
  wideContentWrapper: {
    width: '50%',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

